import { createSlice } from "@reduxjs/toolkit"
import { MapSearchState } from "./types"

const {
    reducer,
    actions: { setMapSearchIsActive, setSearchCoordinate },
} = createSlice({
    name: "map-search",
    initialState: { isActive: false, searchCoordinate: undefined } as MapSearchState,
    reducers: {
        setMapSearchIsActive: (state, action: { payload: boolean }) => {
            state.isActive = action.payload
        },
        setSearchCoordinate: (state, action: { payload: [number, number] | undefined }) => {
            state.searchCoordinate = action.payload
        },
    },
})

export default reducer

export { setMapSearchIsActive, setSearchCoordinate }
